import { IDestination } from "../models/destination";

export const SET_DESTINATION_ZONES = "SET_DESTINATION_ZONES";
export const MERGE_DESTINATION_ZONES = "MERGE_DESTINATION_ZONES";

export interface SetDestinationZones {
    type: typeof SET_DESTINATION_ZONES;
    payload: IDestination[];
}

export interface MergeDestinationZones {
    type: typeof MERGE_DESTINATION_ZONES;
    payload: IDestination[];
}

export type DestinationZonesActionType = SetDestinationZones | MergeDestinationZones;

/**
 * Sets the destination zones from the request.
 * @param payload - The destination zones to set.
 * @returns The action to execute.
 */
export function setDestinationZonesFromRequest(
    payload: IDestination[],
): DestinationZonesActionType {
    return { type: SET_DESTINATION_ZONES, payload };
}

/** Merge partial destination responses without discarding inactive or unrelated entries. */
export function mergeDestinationZonesFromRequest(payload: IDestination[]): MergeDestinationZones {
    return { type: MERGE_DESTINATION_ZONES, payload };
}
